import React from 'react';
import { FaHandsHelping } from 'react-icons/fa';
import childImage from '../assets/img/0.jpeg';
import educationImage from '../assets/img/18__.jpeg';
import supportImage from '../assets/img/19.jpeg';
import Navbar from './NavBar';
import Contact from './Contact';
import pic from '../assets/img/12.jpeg';

const Cause2 = () => {
  return (
    <>
      <Navbar />
      {/* <div>
        <img src={pic} alt='pic' className='w-full lg:h-[540px] h-[50vh] bg-cover bg-top overflow-hidden' />
      </div> */}
      <div className='block lg:hidden'>
        <img
          src={pic}
          alt='pic'
          className='w-full h-[50vh] object-cover'
        />
      </div>

      {/* Large screens: Show colored section with text */}
      {/* <div className='hidden lg:flex items-center justify-center bg-[#c6bab8] h-[540px]'>
        <h1 className='text-5xl font-bold text-[#15381b]'>About</h1>
      </div> */}
      
      <div name='causes' className='w-full min-h-screen bg-[#c6bab8] text-[#15381b] pt-14 pb-10'>
      <div className='hidden lg:flex items-center justify-center bg-[#c6bab8] h-[200px]'>
        <h1 className='text-5xl font-bold text-[#15381b]'>Causes</h1>
      </div>
        <div className='container mx-auto lg:px-32 md:px-20 px-6'>
          <div className='flex flex-col md:flex-row justify-center items-center gap-5'>
            {/* Left Side */}
            <div className='md:w-1/2 md:mr-4 mb-8'>
              <div className='text-lg'>
                <h2 className='text-3xl font-semibold mb-8'>Every child deserves the opportunity to learn.</h2>
                <p className='mb-6'>
                  When young people want to tell their story, we listen. These young people believe in a better tomorrow. They know they can break free from those who doubt their potential and limit their opportunities.
                </p>
                <img src={supportImage} alt='Child' className='rounded-lg w-full h-auto lg:hidden md:hidden' />
                <p className='text-2xl mt-8 lg:mt-0 md:mt-0'>
                We provide opportunities for people from
                economically challenged background to improve themselves and their community, through
                scholarships and study loans.
                </p>
              </div>
              <a
                href='https://iit.edu.ng/support/make-a-contribution'
                target="_blank"
                rel="noopener noreferrer"
                className='inline-block mt-8 bg-[#15381b] text-white text-lg py-4 px-8 rounded-lg shadow-md hover:bg-gray-100 hover:text-[#15381b] focus:outline-none'
              >
                Support Our Cause
              </a>
            </div>

            {/* Right Side */}
            <div className='md:w-1/2 md:ml-4'>
              <img src={supportImage} alt='Child' className='hidden md:block lg:block rounded-lg w-full h-auto' />
            </div>
          </div>
          
          {/* Additional Content Section */}
          <div className='flex flex-col md:flex-row justify-center items-center gap-5 mt-14'>
            {/* Left Side */}
            <div className='md:w-1/2 md:mr-4 mb-8 '>
              <img src={childImage} alt='Child' className='hidden md:block lg:block rounded-lg w-full h-auto' />
            </div>

            {/* Right Side */}
            <div className='md:w-1/2 md:ml-4'>
              <div className='text-lg'>
                <h2 className='text-3xl font-semibold mb-8 lg:mt-[-60px] mt-[-60px]'>Why Education Matters</h2>
                <p className='mb-6'>
                Education is a powerful tool for breaking the cycle of poverty. Young adults who receive quality education are more likely to become self-sufficient, contribute to society, and inspire future generations.
                </p>
                <img src={childImage} alt='Child' className='rounded-lg w-full h-auto lg:hidden md:hidden' />
                <p className='text-2xl mt-8 lg:mt-0 md:mt-0'>
                Our foundation is committed to ensuring that underprivileged young adults receive access to schools, learning materials, and mentorship programs.
                </p>
              </div>
            </div>
          </div>

          {/* Impact Stories Section */}
          <div className='flex flex-col md:flex-row justify-center items-center gap-5 mt-12'>
            {/* Left Side */}
            <div className='md:w-1/2 md:mr-4 mb-8 '>
              <div className='text-lg'>
                <h2 className='text-3xl font-semibold mb-8'>The Impact of Your Support</h2>
                <p className='mb-6'>
                Every donation, volunteer effort,
                and partnership strengthens our ability to make a difference.With your continued support, we
                can expand our reach, touching more lives and creating a ripple effect of positive
                transformation.
                </p>
                <img src={educationImage} alt='Child' className='rounded-lg w-full h-auto  lg:hidden md:hidden' />
                <p className='text-2xl mt-8 lg:mt-0 md:mt-0'>
                We invite you to join us in this mission weather by sponsoring a student or
                donating to our cause. together, we can build a future where African youth are empowered to
                achieve their full potential, uplift their communities, and contribute meaningfully to society.
                </p>
              </div>
              <a
                href='https://iit.edu.ng/support/make-a-contribution'
                target="_blank"
                rel="noopener noreferrer"
                className='inline-block mt-8 bg-[#15381b] text-white text-lg py-4 px-8 rounded-lg shadow-md hover:bg-gray-100 hover:text-[#15381b] focus:outline-none'
              >
                Support Our Cause
              </a>
            </div>

            {/* Right Side */}
            <div className='md:w-1/2 md:ml-4'>
              <img src={educationImage} alt='Child' className='hidden md:block lg:block rounded-lg w-full h-[300px]' />
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default Cause2;
